@if (patient()) {
  <div class="flex shrink-0 items-center justify-between gap-4 bg-white py-2">
    @if (media(); as media) {
      @if (media.length) {
        <div class="flex w-full items-center gap-2">
          <span
            class="my-2 cursor-pointer rounded-full bg-gray-100 px-2 py-1 text-sm transition-all duration-200 hover:bg-gray-200"
            (click)="toggleSelectMode()"
          >
            {{ selectModeText() }}
          </span>

          @if (selectMode()) {
            <button
              mat-icon-button
              matTooltip="Select all media"
              (click)="selectionList.toggleAllSelected()"
            >
              <mat-icon>select_all</mat-icon>
            </button>
          }

          @if (selectionList.selected$ | async; as selected) {
            @if (selected.length) {
              <button
                mat-icon-button
                matTooltip="Download"
                (click)="downloadSelected()"
              >
                <mat-icon>cloud_download</mat-icon>
              </button>

              @if (selected | map: canCopyReferralMediaToPatientFiles : this) {
                <button
                  mat-icon-button
                  matTooltip="Copy to patient files"
                  (click)="copyReferralMediaToPatient()"
                >
                  <mat-icon>file_copy</mat-icon>
                </button>
              }

              @if (selected | map: canDeleteSelected : this) {
                <button
                  mat-icon-button
                  color="warn"
                  matTooltip="Delete"
                  (click)="deleteSelected()"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              }
            }
          }
        </div>
      }
    }
    @if (selectionList.selected$ | async; as selected) {
      @if (selected.length) {
        <p
          class="!m-0 whitespace-nowrap rounded-full bg-gray-100 px-2 py-1 text-xs"
        >
          {{ selected.length }} selected
        </p>
      }
    }

    <div class="ml-auto">
      <ng-content select="attach-file" />
    </div>
  </div>

  @if (media(); as mediaItems) {
    @if (mediaItems.length > 0) {
      <div #mediaContainer class="min-h-0 flex-1 space-y-8 overflow-y-auto p-4">
        @if (groupedMedia(); as groups) {
          @for (group of groups; track group.date) {
            <div>
              <div class="my-2 flex justify-center">
                <div
                  class="rounded-full bg-gray-100 px-3 py-1 text-xs text-gray-500"
                >
                  {{ group.date | moment | amDateFormat: dateFormat }}
                </div>
              </div>
              @for (uploader of group.uploaders; track uploader.uploader) {
                <div class="mb-1 mt-2 text-sm font-bold">
                  {{ uploader.uploader }}
                </div>
                <div class="flex flex-wrap gap-2">
                  @for (media of uploader.media; track media.ref.path) {
                    <div
                      class="group relative h-40 w-64 cursor-pointer overflow-hidden rounded transition-shadow hover:shadow-md"
                      (click)="toggleSelectionOrView(uploader.media, media)"
                    >
                      @defer (on viewport) {
                        <pr-media-tile
                          class="h-full w-full object-cover"
                          [matTooltip]="media.name | removeStorageUid"
                          [media]="media"
                          [showDate]="false"
                          [showImageName]="false"
                          [showFileName]="true"
                        />
                      } @placeholder (minimum 150ms) {
                        <ngx-skeleton-loader animation="pulse" count="5" />
                      }

                      @if (media | map: isSelected$ : this | async) {
                        <div
                          class="absolute inset-0 bg-white/40 transition-opacity duration-100"
                        ></div>
                        <mat-icon
                          class="text-primary-500 absolute left-2 top-2 z-10 rounded-full bg-white"
                        >
                          check_circle
                        </mat-icon>
                      } @else {
                        <div class="invisible group-hover:visible">
                          <pr-referral-media-menu
                            [media]="[media]"
                            [referral]="referral()"
                            [patient]="patient()"
                            [currentUser]="currentUser()"
                            [canManagePatientMedia]="canManagePatientMedia()"
                          />
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
        }
      </div>
    } @else {
      <ng-content select="empty-state" />
    }
  }
} @else {
  <pr-empty-state
    image="list"
    title="patient selected"
    imageClasses="w-32"
    titleClasses="!text-sm"
    [descriptionEnabled]="false"
  />
}
